import { TOLERANCE } from 'config';
import makeVarPersisted from 'hooks/makeVarPersisted';

export const slippageVar = makeVarPersisted<number>(TOLERANCE, 'slippageVar');
export const showTaxPerActionVar = makeVarPersisted<boolean>(
  true,
  'showTaxPerActionVar'
);
